import { FormControl } from '@angular/forms';

import { EmployeeSummaryDTO, RoomSummaryDTO, SpaProductResourceCountDTO, SpaSimpleProductDTO } from '@api';

export function computeResourceAssignmentModes(product: SpaSimpleProductDTO | undefined): {
  employeeAssignmentMode: SpaProductResourceCountDTO;
  roomAssignmentMode: SpaProductResourceCountDTO;
} {
  return {
    employeeAssignmentMode: product?.numEmployees ?? SpaProductResourceCountDTO.ONE_PER_GUEST,
    roomAssignmentMode: product?.numRooms ?? SpaProductResourceCountDTO.ONE_PER_GUEST,
  };
}

export function syncCompanionDetails<T extends { employee?: EmployeeSummaryDTO; room?: RoomSummaryDTO }>(
  mainGuestDetail: Partial<T> | undefined,
  companionControls: FormControl<Partial<T> | undefined>[],
  modes: {
    employeeAssignmentMode: SpaProductResourceCountDTO;
    roomAssignmentMode: SpaProductResourceCountDTO;
  },
): void {
  if (!mainGuestDetail || companionControls.length === 0) {
    return;
  }

  const syncEmployee = modes.employeeAssignmentMode === SpaProductResourceCountDTO.ONE;
  const syncRoom = modes.roomAssignmentMode === SpaProductResourceCountDTO.ONE;

  companionControls.forEach((control) => {
    const patch: Partial<T> = {};
    if (syncEmployee) {
      patch.employee = mainGuestDetail.employee;
    }
    if (syncRoom) {
      patch.room = mainGuestDetail.room;
    }
    if (Object.keys(patch).length > 0) {
      control.patchValue({ ...control.value, ...patch });
    }
  });
}
